import { createContext, PropsWithChildren } from "react";
import { LiftTheme } from "../theme";

export const ThemeContext = createContext<LiftTheme | undefined>(undefined);

ThemeContext.displayName = "ThemeContext";

type ThemeProviderProps = PropsWithChildren<{
    value?: LiftTheme;
    children: React.ReactNode;
}>;

export const ThemeProvider = ({ value, children }: ThemeProviderProps) => {
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
